import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { getAddressCountries } from "../redux/handlers/master/getAddressCountries.handler";
import AddressSelect, { useAddressRows } from "./AddressSelect";
import ThaiAddressSelect from "./ThaiAddressSelect";
import LaoAddressSelect from "./LaoAddressSelect";
export var SHOP_ADDRESS_FIELDS = [
    "sh_branch_countriesid",
    "sh_branch_thprovince_id",
    "sh_branch_thdistrict_id",
    "sh_branch_thsubdistrict_id",
    "sh_branch_laoprovince_id",
    "sh_branch_laodistrict_id",
    "sh_branch_laovillage_id"
];
export var shopAddressIds = function(values) {
    return Object.fromEntries(SHOP_ADDRESS_FIELDS.map(function(field) {
        return [
            field,
            values[field] ? Number(values[field]) : null
        ];
    }));
};
export default function ShopAddressSelect(param) {
    var values = param.values, onChange = param.onChange, error = param.error;
    var _country_countries_shortname;
    var countries = useAddressRows(getAddressCountries, "getAddressCountriesReducer");
    var country = countries.rows.find(function(row) {
        return String(row.countries_id) === String(values.sh_branch_countriesid);
    });
    var code = country === null || country === void 0 ? void 0 : (_country_countries_shortname = country.countries_shortname) === null || _country_countries_shortname === void 0 ? void 0 : _country_countries_shortname.toUpperCase();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AddressSelect, {
                label: "ประเทศ",
                value: values.sh_branch_countriesid,
                required: true,
                error: error,
                source: countries,
                idKey: "countries_id",
                nameKey: "countries_name",
                language: "en",
                onChange: function(option) {
                    var _option_value;
                    return onChange(_object_spread_props(_object_spread({}, shopAddressIds({})), {
                        sh_branch_countriesid: (_option_value = option === null || option === void 0 ? void 0 : option.value) !== null && _option_value !== void 0 ? _option_value : null
                    }));
                }
            }),
            code === "TH" && /*#__PURE__*/ _jsx(ThaiAddressSelect, {
                values: values,
                onChange: onChange
            }),
            code === "LA" && /*#__PURE__*/ _jsx(LaoAddressSelect, {
                values: values,
                onChange: onChange
            })
        ]
    });
}
